import React, { Component } from "react";
class NotFound extends Component {

	render() {
		return (
			<React.Fragment>
				<section className="hero is-fullheight">
					<div className="hero-body">
						<div className="container">
							<h1 className="title">404</h1>
							<h2 className="subtitle">La pagina che cerchi non esiste</h2>
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/views/404.jsx